import { render, staticRenderFns } from "./DataSourceConfiguration.vue?vue&type=template&id=400f5d5c&scoped=true&"
import script from "./DataSourceConfiguration.vue?vue&type=script&lang=js&"
export * from "./DataSourceConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceConfiguration.vue?vue&type=style&index=0&id=400f5d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400f5d5c",
  null
  
)

component.options.__file = "DataSourceConfiguration.vue"
export default component.exports